import { ContactInfo } from './Data';

export const SITE_NAME = 'Q-Tech Contracting';
export const SITE_NAME_AR = 'كيو-تك للمقاولات';

export const SITE_URL = (
  process.env.REACT_APP_SITE_URL || 'https://qtechcontracting.com'
).replace(/\/$/, '');

export const DEFAULT_OG_IMAGE = `${SITE_URL}/assets/images/about/benefit-office.png`;

const KEYWORDS_EN = [
  'contracting company Saudi Arabia',
  'general contractor Saudi Arabia',
  'construction company Saudi Arabia',
  'contracting services KSA',
  'building contractor Al Khobar',
  'construction company Al Khobar',
  'general contractor Eastern Province',
  'civil contracting Saudi Arabia',
  'civil works contractor KSA',
  'mechanical contractor Saudi Arabia',
  'electrical contractor Saudi Arabia',
  'MEP contractor Saudi Arabia',
  'industrial construction Saudi Arabia',
  'industrial contractor KSA',
  'EPC contractor Saudi Arabia',
  'construction company Dammam',
  'contractor Jubail',
  'contractor Yanbu',
  'contractor Ras Al Khair',
  'oil and gas contractor Saudi Arabia',
  'petrochemical construction KSA',
  'infrastructure contractor Saudi Arabia',
  'Q-Tech Contracting',
  'Quality Technologies Contracting',
  'Al Dawood Holding Group',
  'Vision 2030 construction',
  'شركة مقاولات السعودية',
  'مقاولات الخبر',
].join(', ');

const KEYWORDS_AR = [
  'شركة مقاولات',
  'شركة مقاولات في السعودية',
  'شركة مقاولات السعودية',
  'مقاولات عامة',
  'مقاولات عامة السعودية',
  'شركة مقاولات الخبر',
  'شركة مقاولات الدمام',
  'شركة مقاولات الجبيل',
  'شركة مقاولات ينبع',
  'شركة إنشاءات السعودية',
  'شركة إنشاءات المنطقة الشرقية',
  'مقاولات مدنية',
  'مقاولات ميكانيكية',
  'مقاولات كهربائية',
  'مقاولات صناعية',
  'مقاولات MEP',
  'مقاولات النفط والغاز',
  'مقاولات البنية التحتية',
  'أفضل شركة مقاولات',
  'كيو-تك للمقاولات',
  'شركة تقنيات الجودة للمقاولات',
  'مجموعة آل داوود القابضة',
  'Q-Tech Contracting',
].join('، ');

/** Static page SEO — bilingual titles & descriptions tuned for Google EN + AR search intent */
export const PAGE_SEO = {
  home: {
    en: {
      title: 'Contracting Company Saudi Arabia | General Contractor Al Khobar | Q-Tech',
      description:
        'Q-Tech Contracting — leading Saudi general contractor in Al Khobar. Civil, mechanical, electrical, MEP & industrial construction across Dammam, Jubail, Yanbu, Ras Al-Khair & KSA. Get a quote today.',
      keywords: KEYWORDS_EN,
    },
    ar: {
      title: 'شركة مقاولات في السعودية | مقاولات عامة الخبر والدمام | كيو-تك للمقاولات',
      description:
        'كيو-تك للمقاولات — شركة مقاولات عامة سعودية في الخبر. مقاولات مدنية وميكانيكية وكهربائية وصناعية في الدمام والجبيل وينبع ورأس الخير. اطلب عرض سعر الآن.',
      keywords: KEYWORDS_AR,
    },
  },
  about: {
    en: {
      title: 'Saudi Contracting Company | About Q-Tech — Al Khobar General Contractor',
      description:
        'Q-Tech Contracting — Saudi-owned general contractor under Al Dawood Holding Group. Civil, mechanical & industrial construction across the Eastern & Western Province of Saudi Arabia since 2023.',
      keywords: KEYWORDS_EN,
    },
    ar: {
      title: 'شركة مقاولات سعودية | من نحن — كيو-تك للمقاولات الخبر',
      description:
        'كيو-تك للمقاولات — شركة مقاولات عامة سعودية تحت مجموعة آل داوود القابضة. مقاولات مدنية وميكانيكية وصناعية في المنطقة الشرقية والغربية منذ 2023.',
      keywords: KEYWORDS_AR,
    },
  },
  services: {
    en: {
      title: 'Contracting Services Saudi Arabia | Civil, Mechanical & MEP | Q-Tech',
      description:
        'Full contracting services in Saudi Arabia: civil works, mechanical, electrical, instrumentation, insulation, boilers & industrial construction. General contractor Al Khobar — Eastern & Western Province.',
      keywords: `${KEYWORDS_EN}, civil works contractor, mechanical contractor Saudi Arabia, MEP contractor KSA, electrical contracting Saudi Arabia`,
    },
    ar: {
      title: 'خدمات المقاولات في السعودية | مدني، ميكانيكي وكهربائي | كيو-تك',
      description:
        'خدمات مقاولات شاملة في السعودية: أعمال مدنية، ميكانيكية، كهربائية، عزل، غلايات وإنشاءات صناعية. شركة مقاولات عامة في الخبر — المنطقة الشرقية والغربية.',
      keywords: `${KEYWORDS_AR}، مقاولات MEP، مقاولات مدنية ميكانيكية كهربائية`,
    },
  },
  projects: {
    en: {
      title: 'Projects Portfolio | Industrial & Civil Construction | Q-Tech Contracting',
      description:
        'Explore Q-Tech Contracting projects across Saudi Arabia — industrial facilities, civil infrastructure, and multi-discipline construction for government and private clients.',
      keywords: `${KEYWORDS_EN}, construction projects Saudi Arabia, industrial projects Al Khobar`,
    },
    ar: {
      title: 'مشاريعنا | إنشاءات صناعية ومدنية | كيو-تك للمقاولات',
      description:
        'استكشف مشاريع كيو-تك للمقاولات في المملكة — منشآت صناعية، بنية تحتية مدنية، ومقاولات متعددة التخصصات للقطاعين الحكومي والخاص.',
      keywords: KEYWORDS_AR,
    },
  },
  gallery: {
    en: {
      title: 'Project Gallery | Q-Tech Contracting Saudi Arabia',
      description:
        'Photo gallery of Q-Tech Contracting work sites, industrial construction, and civil projects across Al Khobar and the Eastern Province of Saudi Arabia.',
      keywords: KEYWORDS_EN,
    },
    ar: {
      title: 'معرض الصور | كيو-تك للمقاولات',
      description:
        'معرض صور مواقع عمل كيو-تك للمقاولات — إنشاءات صناعية ومشاريع مدنية في الخبر والمنطقة الشرقية.',
      keywords: KEYWORDS_AR,
    },
  },
  blog: {
    en: {
      title: 'Construction Insights & News | Q-Tech Contracting Blog',
      description:
        'Construction industry news, project insights, and contracting expertise from Q-Tech Contracting — Saudi Arabia industrial and civil construction specialists.',
      keywords: `${KEYWORDS_EN}, construction blog Saudi Arabia, contracting news KSA`,
    },
    ar: {
      title: 'مدونة المقاولات والإنشاءات | كيو-تك للمقاولات',
      description:
        'أخبار قطاع الإنشاءات، رؤى المشاريع، وخبرات المقاولات من كيو-تك للمقاولات — متخصصون في الإنشاءات الصناعية والمدنية في السعودية.',
      keywords: KEYWORDS_AR,
    },
  },
  contact: {
    en: {
      title: 'Contact Contracting Company Al Khobar | Q-Tech — Get a Quote',
      description:
        'Contact Q-Tech Contracting — Saudi general contractor in Al Khobar. Phone, email, office map & quote request for civil, mechanical, electrical & industrial construction across Saudi Arabia.',
      keywords: `${KEYWORDS_EN}, contact contractor Al Khobar, construction quote Saudi Arabia, general contractor phone KSA`,
    },
    ar: {
      title: 'اتصل بشركة مقاولات الخبر | كيو-تك — اطلب عرض سعر',
      description:
        'تواصل مع كيو-تك للمقاولات — شركة مقاولات عامة في الخبر. هاتف، بريد، خريطة المكتب وطلب عرض سعر لمشاريع مدنية وميكانيكية وكهربائية وصناعية في المملكة.',
      keywords: `${KEYWORDS_AR}، رقم شركة مقاولات، عرض سعر مقاولات`,
    },
  },
  notFound: {
    en: {
      title: 'Page Not Found | Q-Tech Contracting',
      description: 'The page you are looking for could not be found. Visit Q-Tech Contracting for construction services in Saudi Arabia.',
      keywords: KEYWORDS_EN,
    },
    ar: {
      title: 'الصفحة غير موجودة | كيو-تك للمقاولات',
      description: 'الصفحة التي تبحث عنها غير موجودة. زر كيو-تك للمقاولات لخدمات الإنشاءات في السعودية.',
      keywords: KEYWORDS_AR,
    },
  },
};

export const getPageSeo = (pageKey, locale = 'en') => {
  const lang = locale === 'ar' ? 'ar' : 'en';
  const page = PAGE_SEO[pageKey]?.[lang] || PAGE_SEO.home[lang];
  return {
    title: page.title,
    description: page.description,
    keywords: page.keywords,
    locale: lang,
  };
};

export const buildAbsoluteUrl = (path = '/') => {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_URL}${normalized}`;
};

export const resolveSeoImage = (path) => {
  if (!path) return DEFAULT_OG_IMAGE;
  if (path.startsWith('http')) return path;
  if (path.startsWith('/')) return `${SITE_URL}${path}`;
  return `${SITE_URL}/${path}`;
};

export const buildOrganizationSchema = (locale = 'en') => ({
  '@context': 'https://schema.org',
  '@type': 'GeneralContractor',
  '@id': `${SITE_URL}/#organization`,
  name: locale === 'ar' ? SITE_NAME_AR : SITE_NAME,
  alternateName: [
    'Q-Tech',
    'Quality Technologies Contracting',
    'QTECH Contracting',
    'كيو-تك',
    'كيو-تك للمقاولات',
    'شركة تقنيات الجودة للمقاولات',
    'شركة مقاولات الخبر',
  ],
  url: SITE_URL,
  logo: `${SITE_URL}/assets/images/qtech-logo.png`,
  image: DEFAULT_OG_IMAGE,
  description:
    locale === 'ar'
      ? PAGE_SEO.home.ar.description
      : PAGE_SEO.home.en.description,
  foundingDate: '2023',
  parentOrganization: {
    '@type': 'Organization',
    name: 'Al Dawood Holding Group',
  },
  address: {
    '@type': 'PostalAddress',
    streetAddress: ContactInfo.office_address_line1,
    addressLocality: 'Al Khobar',
    addressRegion: 'Eastern Province',
    postalCode: '34722',
    addressCountry: 'SA',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: ContactInfo.office_map_lat,
    longitude: ContactInfo.office_map_lng,
  },
  telephone: [ContactInfo.contact_phone, ContactInfo.contact_phone2],
  email: ContactInfo.contact_email,
  areaServed: [
    { '@type': 'City', name: 'Al Khobar' },
    { '@type': 'City', name: 'Dammam' },
    { '@type': 'City', name: 'Dhahran' },
    { '@type': 'City', name: 'Jubail' },
    { '@type': 'City', name: 'Yanbu' },
    { '@type': 'City', name: 'Ras Al Khair' },
    { '@type': 'City', name: 'Riyadh' },
    { '@type': 'City', name: 'Jeddah' },
    { '@type': 'AdministrativeArea', name: 'Eastern Province' },
    { '@type': 'Country', name: 'Saudi Arabia' },
  ],
  sameAs: [
    ContactInfo.facebook,
    ContactInfo.instagram,
    ContactInfo.X,
    ContactInfo.tiktok,
  ].filter(Boolean),
  openingHours: 'Mo-Sa 09:00-18:00',
  priceRange: '$$',
  knowsAbout: [
    'General contracting',
    'Civil construction',
    'Civil works',
    'Mechanical contracting',
    'Electrical contracting',
    'MEP contracting',
    'Industrial construction',
    'Instrumentation',
    'Insulation',
    'Boiler systems',
    'EPC',
    'Oil and gas construction',
    'Petrochemical construction',
    'Infrastructure construction',
    'مقاولات عامة',
    'مقاولات',
    'إنشاءات',
    'شركة مقاولات',
  ],
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: locale === 'ar' ? 'خدمات المقاولات' : 'Contracting Services',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: locale === 'ar' ? 'مقاولات مدنية' : 'Civil Works Contracting' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: locale === 'ar' ? 'مقاولات ميكانيكية' : 'Mechanical Contracting' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: locale === 'ar' ? 'مقاولات كهربائية وأجهزة قياس' : 'Electrical & Instrumentation' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: locale === 'ar' ? 'إنشاءات صناعية' : 'Industrial Construction' } },
    ],
  },
});

export const buildWebSiteSchema = (locale = 'en') => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${SITE_URL}/#website`,
  url: SITE_URL,
  name: locale === 'ar' ? SITE_NAME_AR : SITE_NAME,
  description:
    locale === 'ar'
      ? PAGE_SEO.home.ar.description
      : PAGE_SEO.home.en.description,
  publisher: { '@id': `${SITE_URL}/#organization` },
  inLanguage: ['en', 'ar'],
});

export const buildLocalBusinessSchema = (locale = 'en') => ({
  ...buildOrganizationSchema(locale),
  '@type': ['GeneralContractor', 'LocalBusiness'],
  '@id': `${SITE_URL}/#localbusiness`,
  hasMap: ContactInfo.office_maps_share_url,
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: ContactInfo.contact_phone,
    email: ContactInfo.contact_email,
    contactType: 'customer service',
    areaServed: 'SA',
    availableLanguage: ['English', 'Arabic'],
  },
});

export const BREADCRUMB_LABELS = {
  en: {
    home: 'Home',
    about: 'About Us',
    services: 'Services',
    projects: 'Projects',
    gallery: 'Gallery',
    blog: 'Blog',
    contact: 'Contact',
  },
  ar: {
    home: 'الرئيسية',
    about: 'من نحن',
    services: 'خدماتنا',
    projects: 'مشاريعنا',
    gallery: 'المعرض',
    blog: 'المدونة',
    contact: 'اتصل بنا',
  },
};

export const STATIC_SITEMAP_ROUTES = [
  { path: '/', priority: '1.0', changefreq: 'weekly' },
  { path: '/about', priority: '0.9', changefreq: 'monthly' },
  { path: '/services', priority: '0.95', changefreq: 'weekly' },
  { path: '/projects', priority: '0.9', changefreq: 'weekly' },
  { path: '/gallery', priority: '0.7', changefreq: 'monthly' },
  { path: '/blog', priority: '0.8', changefreq: 'weekly' },
  { path: '/contact', priority: '0.85', changefreq: 'monthly' },
];

export const getDefaultBreadcrumbs = (pageKey, locale = 'en') => {
  if (pageKey === 'home' || pageKey === 'notFound') return null;
  const lang = locale === 'ar' ? 'ar' : 'en';
  const labels = BREADCRUMB_LABELS[lang];
  const route = STATIC_SITEMAP_ROUTES.find((item) => {
    const key = item.path.replace('/', '') || 'home';
    return key === pageKey;
  });
  if (!route || !labels[pageKey]) return null;
  return [
    { name: labels.home, path: '/' },
    { name: labels[pageKey], path: route.path },
  ];
};

export const buildBreadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: buildAbsoluteUrl(item.path),
  })),
});

export const buildArticleSchema = ({ title, description, path, image, datePublished }) => ({
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: title,
  description,
  url: buildAbsoluteUrl(path),
  image: resolveSeoImage(image),
  datePublished: datePublished || undefined,
  author: { '@id': `${SITE_URL}/#organization` },
  publisher: { '@id': `${SITE_URL}/#organization` },
});

export const buildServiceSchema = ({ title, description, path, image }) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: title,
  description,
  url: buildAbsoluteUrl(path),
  image: resolveSeoImage(image),
  provider: { '@id': `${SITE_URL}/#organization` },
  areaServed: {
    '@type': 'Country',
    name: 'Saudi Arabia',
  },
});

export const buildProjectSchema = ({ title, description, path, image }) => ({
  '@context': 'https://schema.org',
  '@type': 'CreativeWork',
  name: title,
  description,
  url: buildAbsoluteUrl(path),
  image: resolveSeoImage(image),
  creator: { '@id': `${SITE_URL}/#organization` },
  provider: { '@id': `${SITE_URL}/#organization` },
  inLanguage: ['en', 'ar'],
});

export const buildFaqSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: items.map(({ q, a }) => ({
    '@type': 'Question',
    name: q,
    acceptedAnswer: {
      '@type': 'Answer',
      text: a,
    },
  })),
});

/** Per-service SEO — targets specific Saudi contracting search queries */
export const SERVICE_SEO = {
  'civil-works': {
    en: {
      title: 'Civil Works Contractor Saudi Arabia | General Construction | Q-Tech',
      description:
        'Civil works contracting in Saudi Arabia — foundations, concrete, structural works, roads & infrastructure. Q-Tech general contractor Al Khobar, Dammam, Jubail & KSA.',
      keywords: `${KEYWORDS_EN}, civil works contractor Saudi Arabia, civil construction Al Khobar`,
    },
    ar: {
      title: 'مقاولات أعمال مدنية السعودية | إنشاءات عامة | كيو-تك',
      description:
        'مقاولات أعمال مدنية في السعودية — أساسات، خرسانة، أعمال إنشائية، طرق وبنية تحتية. شركة مقاولات عامة في الخبر والدمام والجبيل.',
      keywords: `${KEYWORDS_AR}، مقاولات مدنية، أعمال مدنية السعودية`,
    },
  },
  'mechanical-work': {
    en: {
      title: 'Mechanical Contractor Saudi Arabia | Piping & Equipment | Q-Tech',
      description:
        'Mechanical contracting in Saudi Arabia — piping, equipment installation, steel structures & industrial mechanical works. Q-Tech Al Khobar serving Eastern & Western Province.',
      keywords: `${KEYWORDS_EN}, mechanical contractor Saudi Arabia, piping contractor KSA`,
    },
    ar: {
      title: 'مقاولات ميكانيكية السعودية | تمديدات ومعدات | كيو-تك',
      description:
        'مقاولات ميكانيكية في السعودية — تمديدات، تركيب معدات، هياكل حديدية وأعمال ميكانيكية صناعية. كيو-تك للمقاولات في الخبر.',
      keywords: `${KEYWORDS_AR}، مقاولات ميكانيكية، مقاول تمديدات`,
    },
  },
  'electrical-instrument': {
    en: {
      title: 'Electrical & Instrumentation Contractor KSA | E&I Works | Q-Tech',
      description:
        'Electrical and instrumentation contracting in Saudi Arabia — power, control systems, E&I installation for industrial & oil/gas facilities. Q-Tech Al Khobar.',
      keywords: `${KEYWORDS_EN}, electrical contractor Saudi Arabia, instrumentation contractor KSA, E&I contractor`,
    },
    ar: {
      title: 'مقاولات كهربائية وأجهزة قياس السعودية | أعمال E&I | كيو-تك',
      description:
        'مقاولات كهربائية وأجهزة قياس في السعودية — طاقة، أنظمة تحكم، تركيب E&I للمنشآت الصناعية والنفط والغاز. كيو-تك الخبر.',
      keywords: `${KEYWORDS_AR}، مقاولات كهربائية، مقاولات أجهزة قياس`,
    },
  },
  'insulation-work': {
    en: {
      title: 'Insulation Contractor Saudi Arabia | Thermal & Industrial | Q-Tech',
      description:
        'Industrial insulation contracting in Saudi Arabia — thermal, acoustic & protective insulation for pipelines, vessels & equipment. Q-Tech general contractor KSA.',
      keywords: `${KEYWORDS_EN}, insulation contractor Saudi Arabia, thermal insulation KSA`,
    },
    ar: {
      title: 'مقاولات عزل السعودية | عزل حراري وصناعي | كيو-تك',
      description:
        'مقاولات عزل صناعي في السعودية — عزل حراري وصوتي وحماية للأنابيب والخزانات والمعدات. شركة مقاولات في الخبر.',
      keywords: `${KEYWORDS_AR}، مقاولات عزل، عزل حراري صناعي`,
    },
  },
  'boiler-combustion': {
    en: {
      title: 'Boiler & Combustion Systems Contractor KSA | Q-Tech',
      description:
        'Boiler and combustion systems contracting in Saudi Arabia — installation, maintenance & industrial boiler works. Q-Tech mechanical contractor Al Khobar.',
      keywords: `${KEYWORDS_EN}, boiler contractor Saudi Arabia, combustion systems KSA`,
    },
    ar: {
      title: 'مقاولات غلايات وأنظمة احتراق السعودية | كيو-تك',
      description:
        'مقاولات غلايات وأنظمة احتراق في السعودية — تركيب وصيانة وأعمال غلايات صناعية. كيو-تك للمقاولات الخبر.',
      keywords: `${KEYWORDS_AR}، مقاولات غلايات، أنظمة احتراق`,
    },
  },
  'industrial-construction': {
    en: {
      title: 'Industrial Construction Contractor Saudi Arabia | Q-Tech',
      description:
        'Industrial construction contracting in Saudi Arabia — plants, facilities, multi-discipline EPC & industrial builds. Q-Tech general contractor Eastern Province & KSA.',
      keywords: `${KEYWORDS_EN}, industrial construction Saudi Arabia, industrial contractor Al Khobar`,
    },
    ar: {
      title: 'مقاولات إنشاءات صناعية السعودية | كيو-تك للمقاولات',
      description:
        'مقاولات إنشاءات صناعية في السعودية — مصانع ومنشآت ومشاريع EPC متعددة التخصصات. شركة مقاولات عامة في المنطقة الشرقية.',
      keywords: `${KEYWORDS_AR}، إنشاءات صناعية، مقاولات مصانع`,
    },
  },
};

export const getServiceSeo = (slug, locale = 'en', fallbackTitle = '') => {
  const lang = locale === 'ar' ? 'ar' : 'en';
  const preset = SERVICE_SEO[slug]?.[lang];
  if (preset) return { ...preset, locale: lang };
  const siteName = lang === 'ar' ? SITE_NAME_AR : SITE_NAME;
  return {
    title: fallbackTitle ? `${fallbackTitle} | ${siteName}` : getPageSeo('services', lang).title,
    description: getPageSeo('services', lang).description,
    keywords: getPageSeo('services', lang).keywords,
    locale: lang,
  };
};
